/* jshint devel:false */
/* global hemavantarnaby, slick, event, currentSlide, nextSlide */
import "./vendor/bootstrap.js";
import "./vendor/jquery.countdown.js";
import "./vendor/js.cookie.js";
import "./vendor/lightcase.js";
import "./vendor/simplegmaps.js";
import "./vendor/slick.js";
// import "./vendor/ss-glyphish-outlined.js"; // Removed - not needed for modern browsers

/**
 * App
 */
(function (root, document, $) {
  "use strict";
  var app = {
    init: function () {
      this.win = $(window);
      this.doc = $(document);
      this.isTouch = "ontouchstart" in document.documentElement;

      // Cache elements
      this.html = $("html");
      this.body = $("body");
      this.todaysEventsEl = $(".todays-events");
      this.heroSliderEl = $(".hero-slider");
      this.sliderEl = $(".component-slideshow");
      this.heroEl = $(".hero");
      this.galleryEl = $(".gallery-item a");
      this.spinner = $(".spinner");
      this.mapEl = $(".google-map");
      this.primaryNavEl = $(".site-nav > ul > li");
      this.searchToggleEl = $(".site-search > a");
      this.siteSearchEl = $(".site-search");
      this.gravityFormsEl = $(".gform_wrapper");
      this.webCamEl = $(".img-webcam");
      this.heroWeatherEl = $(".todays-weather");
      this.weatherReportEl = $(".component-weather_pistinfo");

      // Init sub objects
      for (var name in this) {
        if (typeof this[name].init === "function") {
          this[name].init();
        }
      }

      this.syncTodaysEventsViewport();
      this.win.on("resize", $.proxy(this.syncTodaysEventsViewport, this));

      this.body.addClass("is-loaded");
    },

    BREAKPOINT: 768,

    syncTodaysEventsViewport: function () {
      var el = this.todaysEventsEl;
      if (!el.length) return;
      var expandOnHome = el.attr("data-expand-on-home") === "1";
      var isWide = this.win.width() >= this.BREAKPOINT;
      var arrow = el.find(".today-toggle i");
      if (isWide && expandOnHome) {
        el.addClass("open");
        arrow.removeClass("ss-down").addClass("ss-up");
      } else {
        el.removeClass("open");
        arrow.removeClass("ss-up").addClass("ss-down");
      }
    },

    bindUiActions: {
      init: function () {
        var t = app;

        var offCanvasNav = t.body.find(".off-canvas");

        offCanvasNav
          .find(".off-canvas-nav > ul > .menu-item-has-children")
          .each(function () {
            $(this)
              .find("> a")
              .after(
                '<button class="off-canvas-nav-toggle js-toggle-sub-nav"><i class="ss-down"></i></button>'
              );
          })
          .end()
          .find(
            'li[class*="current"], li[class*="current"] > .off-canvas-nav-toggle'
          )
          .addClass("is-active");

        t.body.on("click", ".js-scroll-to-booking", function (e) {
          e.preventDefault();

          $("html, body").animate(
            {
              scrollTop: $("#book-now").position().top,
            },
            400
          );
        });

        app.body
          .on("click", ".today-toggle", function () {
            var arrow = $(this).find("i");
            t.todaysEventsEl.toggleClass("open");
            if (t.todaysEventsEl.hasClass("open")) {
              arrow.removeClass("ss-down").addClass("ss-up");
            } else {
              arrow.removeClass("ss-up").addClass("ss-down");
            }
          })
          .on("click", ".js-show-off-canvas", function () {
            t.body.toggleClass("off-canvas-visible");
          })
          .on("click", ".js-close-off-canvas", function () {
            t.body.removeClass("off-canvas-visible");
          })
          .on("click", ".js-toggle-sub-nav", function () {
            $(this).toggleClass("is-active").parent().toggleClass("is-active");
          });

        // Search toggle
        t.searchToggleEl.on("click", function (e) {
          var _t = $(this),
            _p = _t.parent();

          _p.toggleClass("open");

          t.body
            .find(".Citybreak_CompactBasket .cb_bd")
            .css({ display: "none" });

          e.preventDefault();

          if (_p.hasClass("open")) {
            $(".site-search input").focus();
          }
        });

        t.doc.on("click keydown touchend", function (e) {
          var target = $(e.target);

          if (!t.siteSearchEl.has(target).length) {
            t.siteSearchEl.removeClass("open");
          }

          if (
            ("click" === e.type || "touchend" === e.type) &&
            (target.is(".js-show-off-canvas") ||
              target.parents(".js-show-off-canvas").length ||
              target.parents(".off-canvas").length)
          ) {
            return;
          } else if ("keydown" === e.type && 27 !== e.keyCode) {
            return;
          }

          t.body.removeClass("off-canvas-visible");
        });

        // video modal iframe src
        $("#modal-video")
          .on("shown.bs.modal", function (e) {
            var video = $(e.relatedTarget).data("video");
            $(this)
              .find(".embed-responsive")
              .html(
                '<iframe class="embed-responsive-item" height="350" src="https://www.youtube.com/embed/' +
                  video +
                  '?html5=1&autoplay=1">'
              );
          })
          .on("hidden.bs.modal", function () {
            $(this).find(".embed-responsive").html("");
          });

        // lightcase gallery
        t.galleryEl.lightcase({
          showSequenceInfo: false,
          transition: "scrollHorizontal",
          showCaption: false,
          maxWidth: 2000,
          maxHeight: 2000,
        });

        // expand gallery
        $(".component-tabs").on("click", ".expand", function (e) {
          e.preventDefault();
          $("#image-gallery .expand-container").slideDown();
          $(this).fadeOut(150);
        });

        // google map
        if (t.mapEl.length > 0) {
          t.mapEl.simplegmaps();

          $('a[data-toggle="tab"]').on("shown.bs.tab", function (e) {
            var tabHref = $(e.target).attr("href");
            if (tabHref === "#map") {
              t.mapEl.simplegmaps("resize");
            }
          });
        }

        // mega menu
        t.primaryNavEl.each(function (i, item) {
          var _t = $(this),
            image = _t.data("image"),
            megaMenuImage = _t.find(".mega-sub").find(".menu-image");

          if (typeof image !== "undefined") {
            megaMenuImage.html(
              '<img src="' + image + '" class="img-responsive">'
            );
          }
        });

        $(".mega-sub .sub-menu > li.column").each(function () {
          $(this)
            .nextUntil(".column")
            .wrapAll('<ul class="mega-menu-column"></ul>');
        });
      },
    },
    weatherPistData: {
      init: function () {
        var _component = app.weatherReportEl,
          _widget = app.heroWeatherEl;

        if (_component.length === 0 && _widget.length === 0) {
          return;
        }

        $.post(
          hemavantarnaby.ajaxurl,
          {
            action: "hemavan_weather_pist_data",
          },
          function (response) {
            console.log(response, 'response from weather pist data');
            var weather = response.data.weather,
              icon = weather.hemavan.now.icon,
              tempWind = weather.hemavan.now.temp_wind,
              tableRow = "",
              snowDepthType = hemavantarnaby.snow_depth,
              weatherNowHtml =
                "<ul><li>" + icon + "</li><li>" + tempWind + "</li></ul>";

            // Widget
            //if ( typeof response.data.weather.now !== 'undefined' ) {
            _widget.find(".weather-now").html(weatherNowHtml);
            //}

            $.each(response.data.stats, function (i, item) {
              var headline = "hemavan" === i ? "Hemavan" : "Tärnaby",
                snowDepth =
                  "nature" === snowDepthType
                    ? item.snow.nature
                    : item.snow.pist,
                tLift = parseInt(item.lift.open) + parseInt(item.lift.closed),
                tPist = parseInt(item.pist.open) + parseInt(item.pist.closed);

              tableRow +=
                '<tr><td colspan="2"><h5>' +
                headline +
                "</h5></td></tr><tr><td>" +
                hemavantarnaby.text.pists +
                "</td><td>" +
                item.pist.open +
                " / " +
                tPist +
                "</td></tr><tr><td>" +
                hemavantarnaby.text.lifts +
                "</td><td>" +
                item.lift.open +
                " / " +
                tLift +
                "</td></tr><tr><td>" +
                hemavantarnaby.text.snow_depth +
                "</td><td>" +
                snowDepth +
                " cm</td></tr>";
            });
            _widget
              .find(".pist-lift-data")
              .html("<table><tbody>" + tableRow + "</tbody></table>");

            // Component
            if (_component.length > 0) {
              var tarnabyIcon = weather.tarnaby.now.icon,
                tarnabytempWind = weather.tarnaby.now.temp_wind,
                tarnabyWeatherNowHtml =
                  "<ul><li>" +
                  tarnabyIcon +
                  "</li><li>" +
                  tarnabytempWind +
                  "</li></ul>";

              // lift/pist status
              $.each(response.data.stats, function (i, item) {
                _component
                  .find("#pist-" + i + " .lifts-status .open")
                  .html(item.lift.open);
                _component
                  .find("#pist-" + i + " .lifts-status .closed")
                  .html(item.lift.closed);
                _component
                  .find("#pist-" + i + " .pists-status .open")
                  .html(item.pist.open);
                _component
                  .find("#pist-" + i + " .pists-status .closed")
                  .html(item.pist.closed);
              });

              //if ( typeof response.data.weather.now !== 'undefined' ) {
              _component
                .find("#pist-hemavan .weather-now")
                .html(weatherNowHtml);
              _component
                .find("#pist-tarnaby .weather-now")
                .html(tarnabyWeatherNowHtml);

              // forecast
              $.each(weather, function (i, item) {
                var forecastHtml = "";
                $.each(item.forecast, function (i, item) {
                  forecastHtml +=
                    '<div class="col-xs-6 col-sm-3 text-center">' +
                    item.icon +
                    "<h4>" +
                    item.day +
                    "</h4>" +
                    item.temp_wind +
                    "</div>";
                });
                _component
                  .find("#pist-" + i + " .weather-forecast")
                  .html(forecastHtml);
              });
              //}
            }
          }
        );
      },
    },
    webCam: {
      init: function () {
        if (app.webCamEl.length === 0) {
          return;
        }

        var date = new Date(),
          t = this;

        t.updateImages();

        setTimeout(function () {
          setInterval(t.updateImages, 60000);
          t.updateImages();
        }, (60 - date.getSeconds()) * 1000);
      },
      updateImages: function () {
        app.webCamEl.each(function () {
          var imgSrc = $(this).attr("src");
          $(this).attr("src", imgSrc);
        });
      },
    },

    gravityForms: {
      init: function () {
        if (app.gravityFormsEl.length === 0) {
          return;
        }
        var t = this,
          isApplication = app.gravityFormsEl.hasClass("job-application-form");

        app.doc.bind("gform_post_render", function () {
          t.bindEvents();
          if (isApplication) {
            t.listSteps();
          }
        });

        if (isApplication) {
          t.listSteps();
        }

        t.bindEvents();
      },
      bindEvents: function () {
        var t = this;
        app.gravityFormsEl
          .on("click", "button", function () {
            $(this).addClass("loading");
          })
          .on("click", ".gfield_list_icons img", t.listSteps);
        //.on( 'click', '.gfield_list_icons .delete_list_item', t.listSteps )
      },
      listSteps: function () {
        var listRows = app.gravityFormsEl.find(".job-list table tr"),
          count = 1;

        listRows.each(function () {
          var td = $(this).find("> td:first-child");
          td.find(".list-nr").remove();
          td.prepend('<span class="list-nr"></span>')
            .find(".list-nr")
            .html("<span></span>");
        });
      },
    },

    slider: {
      init: function () {
        if (app.sliderEl.length === 0 && app.heroSliderEl.length === 0) {
          return;
        }
        var _hero = this,
          fromTop = app.body.hasClass("logged-in") ? 177 : 145,
          settings = {
            fade: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: true,
            swipe: app.isTouch ? true : false,
            autoplay: true,
            autoplaySpeed: 7000,
            infinite: true,
            pauseOnHover: true,
            accessibility: true,
          };

        // set height and init hero slider
        if (app.heroSliderEl.length > 0) {
          settings.autoplay = false;
          app.heroSliderEl.slick(settings);
          app.heroSliderEl
            .css("display", "block")
            .prev(".fake-element")
            .css("display", "none");
        }

        // init default slideshow
        if (app.sliderEl.length > 0) {
          app.sliderEl.slick(settings);
          app.sliderEl.css("display", "block");
        }
      },
      setHeight: function (fromTop) {
        var windowHeight = app.win.innerHeight() - fromTop;
        app.heroSliderEl
          .css("height", windowHeight)
          .prev(".fake-element")
          .css("height", windowHeight);
      },
    },

    socialFeeds: {
      config: {
        component: $(".component-social_media_feed"),
        paged: 1,
        ajaxRequest: null,
      },

      init: function () {
        if (!this.config.component.length) {
          return;
        }

        this.config.term = "";
        this.config.ajaxResultsEl =
          this.config.component.find(".js-ajax-results");
        this.config.ajaxPagerEl = this.config.component.find(".js-pager");
        this.config.ajaxLoadMoreEl =
          this.config.component.find(".js-load-more");
        this.config.postType = "";

        this.bindUiActions();
        this.getPosts();
      },

      bindUiActions: function () {
        var scope = this;

        scope.config.component
          .on("click", ".js-load-more", function () {
            scope.config.ajaxLoadMoreEl.addClass("btn-loading");

            scope.config.paged++;

            scope.getPosts();
          })

          .on("click", ".js-social-filter li a", function (e) {
            e.preventDefault();

            var source = $(this).data("source");

            if ("all" === source) {
              scope.config.term = "";
              scope.config.postType = "";
              scope.activateNavItem("all");
            } else if ("blog" === source) {
              scope.config.term = "";
              scope.config.postType = "blog";
              scope.activateNavItem("blog");
            } else {
              scope.config.term = $(this).data("source");
              scope.config.postType = "";
              scope.activateNavItem($(this).data("source"));
            }

            scope.config.paged = 1;

            scope.getPosts();
          });
      },

      activateNavItem: function (source) {
        var scope = this;

        if (source) {
          scope.config.component
            .find(".js-social-filter li a")
            .removeClass("active");
          scope.config.component
            .find('.js-social-filter li a[data-source="' + source + '"]')
            .addClass("active");
        }
      },

      getPosts: function () {
        var scope = this;

        if (null !== scope.config.ajaxRequest) {
          scope.config.ajaxRequest.abort();
          scope.config.ajaxRequest = null;
        }

        if (1 === scope.config.paged) {
          scope.config.ajaxResultsEl.html("");
          scope.config.ajaxResultsEl.append('<div class="is-loading"></div>');
          scope.config.ajaxPagerEl.addClass("hidden");
        } else {
          scope.config.ajaxResultsEl.find(".is-loading").remove();
        }

        scope.config.ajaxRequest = $.post(hemavantarnaby.ajaxurl, {
          action: "get_social_posts",
          term: scope.config.term,
          paged: scope.config.paged,
          postType: scope.config.postType,
        })

          .done(function (response) {
            if ("undefined" === typeof response.data) {
              return;
            }

            if (1 < scope.config.paged) {
              scope.config.ajaxResultsEl.append(response.data.posts);
            } else {
              scope.config.ajaxResultsEl.html(response.data.posts);
            }

            if (response.data.paging) {
              scope.config.ajaxPagerEl.removeClass("hidden");
            } else {
              scope.config.ajaxPagerEl.addClass("hidden");
            }
          })

          .fail(function (response) {
            if ("undefined" === typeof response.responseJSON.data) {
              return;
            }

            scope.config.ajaxResultsEl.html(response.responseJSON.data);
          })

          .always(function (response) {
            scope.config.ajaxLoadMoreEl.removeClass("btn-loading");
            scope.config.ajaxResultsEl.find(".is-loading").remove();
          });
      },
    },

    socialFeedsOld: {
      // config: {
      // 	limit: 6,
      // 	templateData: [],
      // 	resultsEl: $( '.social-feeds-data' ),
      // 	paged: 1,
      // 		ajaxRequest: null,
      // },
      // data: {},
      // init: function() {
      // 	var scope = this;
      // 	if ( app.socialFeedsEl.length === 0 ) {
      // 		return;
      // 	}
      // 	// $.getJSON( hemavantarnaby.socialfeedurl, function( response ) {
      // 	// 	scope.data = response;
      // 	// 	scope.renderTemplate();
      // 	// });
      // 	if ( null !== scope.config.ajaxRequest ) {
      // 			scope.config.ajaxRequest.abort();
      // 			scope.config.ajaxRequest = null;
      // 		}
      // 		scope.config.ajaxRequest = $.post(
      // 			hemavantarnaby.ajaxurl, {
      // 			action: 'get_social_posts',
      // 		},
      // 		function( response ) {
      // 			scope.data = response;
      // 			scope.renderTemplate();
      // 		});
      // 	app.socialFeedsEl
      // 		.on( 'click', '.filter a', scope.handleFilter )
      // 		.on( 'click', '.js-show-all', function( e ) {
      // 			e.preventDefault();
      // 			var btn = $( this );
      // 			if ( 'more' === btn.attr( 'data-action' ) ) {
      // 				scope.config.resultsEl.find( '.feed-item' ).removeClass( 'hidden' );
      // 				btn
      // 					.attr( 'data-action', 'less' )
      // 					.text( btn.data( 'show-less' ) );
      // 			} else {
      // 				scope.config.resultsEl.find( '.feed-item' ).eq( 5 ).nextAll().addClass( 'hidden' );
      // 				btn
      // 					.attr( 'data-action', 'more' )
      // 					.text( btn.data( 'show-more' ) );
      // 				$( 'html, body' ).animate({
      // 					scrollTop: app.socialFeedsEl.offset().top
      // 				}, 300 );
      // 			}
      // 		});
      // },
      // renderTemplate: function() {
      // 	var scope = this,
      // 		html = '';
      // 	if ( typeof( scope.data ) === 'undefined' ) {
      // 		scope.config.resultsEl.find( '.no-data-found' ).show();
      // 		return;
      // 	}
      // 	$.each( scope.data.data.posts, function( i, item ) {
      // 		if ( item.source === 'sommartopparhemavantarnaby' ) {
      // 			return;
      // 		}
      // 		var icon = 'fa fa-' + item.source + '-square',
      // 			hiddenClass = '',
      // 			target = ( item.source === 'blog' || item.source === 'youtube' ? '' : ' target="_blank"' );
      // 		// icons
      // 		if ( item.source === 'instagram' ) {
      // 			icon += icon.replace( '-square', '' );
      // 		} else if ( item.source === 'blog' ) {
      // 			icon = 'fa fa-pencil-square-o';
      // 		}
      // 		if ( i > 5 ) {
      // 			hiddenClass = 'hidden';
      // 		}
      // 		html += '<div class="col-sm-6 col-md-4 feed-item ' + hiddenClass + ' source-' + item.source + '">';
      // 			if ( item.source !== 'twitter' ) {
      // 				if ( item.source === 'youtube' ) {
      // 					html += '<a href="#" data-video="' + item.id + '" data-toggle="modal" data-target="#modal-video" class="inside">';
      // 				} else {
      // 					html += '<a href="' + item.permalink + '" class="inside"' + target + '>';
      // 				}
      // 			} else {
      // 				html += '<div class="inside">';
      // 			}
      // 			html += '<div class="item-content">';
      // 				if ( typeof( item.thumbnail ) !== 'undefined' ) {
      // 					html += '<figure class="feed-item-bg" style="background-image: url(' + item.thumbnail + ');"></figure>';
      // 				}
      // 				html += '<div class="feed-item-content">';
      // 				if ( typeof( item.title ) !== 'undefined' ) {
      // 					html += '<h4 class="feed-item-title">' + item.title + '</h4>';
      // 				}
      // 				if ( typeof( item.content ) !== 'undefined' && '' !== item.content ) {
      // 					html += '<p>' + item.content + '</p>';
      // 				}
      // 				html += '<div class="feed-item-source"><i class="fa fa-' + icon + '"></i> ' + item.source_name + '</div>';
      // 				html += '</div>';
      // 			html += '</div></a>';
      // 		html += '</div></div>';
      // 	});
      // 	scope.config.resultsEl.html( html );
      // 	if ( app.socialFeedsEl.find( '.feed-item' ).length > 6 ) {
      // 		app.socialFeedsEl.find( '.button-area' ).show();
      // 	}
      // },
      // handleFilter: function( e ) {
      // 	var _t = $(this),
      // 		source = _t.data( 'source' );
      // 	e.preventDefault();
      // 	if ( _t.hasClass( 'active' ) ) {
      // 		return;
      // 	}
      // 	app.socialFeedsEl
      // 		.find( '.filter a' )
      // 		.removeClass( 'active' );
      // 	_t.addClass( 'active' );
      // 	if ( 'all' === source ) {
      // 		app.socialFeeds.renderTemplate();
      // 	} else {
      // 		var btn = app.socialFeedsEl.find( '.js-show-all' );
      // 		btn
      // 			.attr( 'data-action', 'more' )
      // 			.text( btn.data( 'show-more' ) );
      // 		app.socialFeedsEl
      // 			.find( '.button-area' ).hide()
      // 			.end()
      // 			.find( '.feed-item' )
      // 				.removeClass( 'hidden' )
      // 			.end()
      // 			.find( '[class*="source-"]:not(".source-' + source + '")' )
      // 				.addClass( 'hidden' );
      // 	}
      // }
    },

    cityBreakWidget: {
      config: {
        wrapper: $(".widget_citybreak"),
        trigger: $(".booking-select select"),
      },

      init: function () {
        var scope = this,
          config = scope.config;

        if (config.wrapper.length == 0) {
          return;
        }

        config.trigger.on("change", function () {
          var val = $(this).val();

          config.wrapper.find(".widget-panel").css({ display: "none" });
          config.wrapper.find("#widget-panel-" + val).css({ display: "block" });
        });
      },
    },

    bookingWidget: {
      config: {
        wrapper: $(".booking-form"),
      },

      init: function () {
        var scope = this;

        if (!scope.config.wrapper.length) {
          return;
        }

        scope.config.wrapper
          .find("#cb_acc_weekpicker_cnt_moveme .cb_titlelabel")
          .text(scope.config.wrapper.data("weekpickerLabel"));
      },
    },

    localSlideshow: {
      init: function () {
        var slideshow = $("body").find(".component-local-slideshow-slides");

        if (!slideshow.length) {
          return;
        }

        slideshow.slick({
          centerMode: true,
          centerPadding: "200px",
          slidesToShow: 1,
          initialSlide: 1,
          infinite: false,
          prevArrow:
            '<button type="button" class="slick-prev"><i class="ss-left"></i></button>',
          nextArrow:
            '<button type="button" class="slick-next"><i class="ss-right"></i></button>',
          responsive: [
            {
              breakpoint: 991,
              settings: {
                centerPadding: "100px",
              },
            },
            {
              breakpoint: 600,
              settings: {
                centerPadding: 0,
              },
            },
          ],
        });
      },
    },

    /**
     * Responsive nav
     */
    responsive: {
      config: {
        wrapper: $(".responsive-functions"),
        searchForm: $(".search-form-wrapper"),
      },
      init: function () {
        var scope = this;
        //Register click events for menu buttons
        // $('a.hamburger-nav').on( 'click', function( e ) {
        // 	if( app.body.hasClass('active-menu') ) {
        // 		app.body.removeClass('active-menu');
        // 	}
        // 	else {
        // 		app.body.addClass('active-menu');
        // 	}
        // 	e.preventDefault();
        // });

        scope.config.wrapper
          .on("click", ".hamburger-nav", function (e) {
            if (app.body.hasClass("active-menu")) {
              app.body.removeClass("active-menu");
            } else {
              app.body.addClass("active-menu");
            }
            e.preventDefault();
          })
          .on("click", ".search-toggle", function (e) {
            if (scope.config.searchForm.hasClass("visible")) {
              scope.config.searchForm.removeClass("visible");
            } else {
              scope.config.searchForm.addClass("visible").find("input").focus();
            }
            e.preventDefault();
          });

        //Exit clicks
        app.doc.bind("touchend", function (e) {
          var $target = $(e.target);
          if (
            !$target.hasClass("responsive-menu") &&
            !$target.parent().hasClass("responsive-menu") &&
            !$target.hasClass("responsive-navigation") &&
            !$target.parents().hasClass("responsive-navigation")
          ) {
            app.body.removeClass("active-menu");
          }
        });
        app.html.click(function (e) {
          var $target = $(e.target);
          if (
            !$target.hasClass("responsive-menu") &&
            !$target.parent().hasClass("responsive-menu") &&
            !$target.hasClass("responsive-navigation") &&
            !$target.parents().hasClass("responsive-navigation")
          ) {
            app.body.removeClass("active-menu");
          }
        });

        //Add markup
        $(".responsive-navigation li.menu-item-has-children").each(function () {
          $(this).append('<span class="toggle"></span>');
        });

        //toggle events
        $(".responsive-navigation span.toggle").on("click", function () {
          var t = $(this);

          if (t.hasClass("active")) {
            t.removeClass("active");
            t.parent().removeClass("active");
          } else {
            t.addClass("active");
            t.parent().addClass("active");
          }
        });

        //Open current pages
        $(
          '.responsive-navigation li[class*="current"], .responsive-navigation li[class*="current"] > .toggle'
        ).addClass("active");
      },
    },

    takeOver: {
      init: function () {
        var modalTakeover = app.body.find(".modal-takeover"),
          countDown = app.body.find(".countdown");

        if (0 === modalTakeover.length) {
          return;
        }

        app.body.on("click", ".js-hide-takeover", function (e) {
          e.preventDefault();

          Cookies.set("takeover_disabled", 1);

          modalTakeover.modal("hide");
        });

        if (Cookies.get("takeover_disabled")) {
          return;
        }

        $(app.win).load(function () {
          modalTakeover.modal("show");
        });

        countDown.countdown(countDown.data("deadline"), function (e) {
          $(this).html(
            e.strftime(
              '<div class="countdown-cell cell-days"><span class="nr">%-D</span> <span class="label">dag%!D:ar;</span></div>\
		 					<div class="countdown-cell cell-hours"><span class="nr">%-H</span> <span class="label">%!H:timme,timmar;</span></div>\
		 					<div class="countdown-cell cell-minutes"><span class="nr">%-M</span> <span class="label">%!M:minut,minuter;</span></div>\
		 					<div class="countdown-cell cell-seconds"><span class="nr">%-S</span> <span class="label">%!S:sekund,sekunder;</span></div>\
		 				'
            )
          );
        });
      },
    },

    magazine: {
      config: {
        component: $(".component-magazine"),
        paged: 1,
        ajaxRequest: null,
      },

      init: function () {
        if (!this.config.component.length) {
          return;
        }

        this.config.taxonomy = this.config.component.data("taxonomy");
        this.config.termId = this.config.component.data("termId");
        this.config.excludeIds = this.config.component.data("excludeIds");
        this.config.ajaxResultsEl =
          this.config.component.find(".js-ajax-results");
        this.config.ajaxPagerEl = this.config.component.find(".js-pager");
        this.config.ajaxLoadMoreEl =
          this.config.component.find(".js-load-more");

        this.bindUiActions();
      },

      bindUiActions: function () {
        var scope = this;

        scope.config.component
          .on("click", ".js-load-more", function () {
            scope.config.ajaxLoadMoreEl.addClass("btn-loading");

            scope.config.paged++;

            scope.getPosts();
          })
          .on("change", ".js-magazine-filter", function () {
            window.location.href = $(this).val();
          })
          .on("click", ".js-magazine-share", function () {
            var t = $(this);

            t.parent().toggleClass("is-active");
          });
      },

      getPosts: function () {
        var scope = this;

        if (null !== scope.config.ajaxRequest) {
          scope.config.ajaxRequest.abort();
          scope.config.ajaxRequest = null;
        }

        scope.config.ajaxRequest = $.post(hemavantarnaby.ajaxurl, {
          action: "get_magazine_posts",
          taxonomy: scope.config.taxonomy,
          termId: scope.config.termId,
          paged: scope.config.paged,
          excludeIds: scope.config.excludeIds,
        })
          .done(function (response) {
            if ("undefined" === typeof response.data) {
              return;
            }

            if (1 < scope.config.paged) {
              scope.config.ajaxResultsEl.append(response.data.posts);
            }

            if (response.data.paging) {
              scope.config.ajaxPagerEl.removeClass("hidden");
            } else {
              scope.config.ajaxPagerEl.addClass("hidden");
            }
          })
          .fail(function (response) {
            if ("undefined" === typeof response.responseJSON.data) {
              return;
            }

            scope.config.ajaxResultsEl.html(response.responseJSON.data);
          })
          .always(function (response) {
            scope.config.ajaxLoadMoreEl.removeClass("btn-loading");
          });
      },
    },
    instagramHashtag: {
      config: {
        component: $(".js-instagram-hashtag-grid"),
        wrapper: $(".js-instagram-hashtag__grid-wrapper"),
      },

      init: function () {
        var scope = this;
        if (!scope.config.component.length) {
          return;
        }

        scope.getInstaPosts();

        scope.config.wrapper.on("click", ".js-show-all", function (e) {
          e.preventDefault();

          var btn = $(this);

          if ("more" === btn.attr("data-action")) {
            scope.config.component.find(".feed-item").removeClass("hidden");

            btn.attr("data-action", "less").text(btn.data("show-less"));
          } else {
            scope.config.component
              .find(".feed-item")
              .eq(5)
              .nextAll()
              .addClass("hidden");

            btn.attr("data-action", "more").text(btn.data("show-more"));

            $("html, body").animate(
              {
                scrollTop: scope.config.wrapper.offset().top,
              },
              300
            );
          }
        });
      },

      getInstaPosts: function () {
        var scope = this;

        alert("in getInstaPosts??");

        // $.getJSON( hemavantarnaby.socialfeedurl, function( response ) {
        // 	scope.data = response;

        // 	scope.renderTemplate();
        // });

        $.post(
          hemavantarnaby.ajaxurl,
          {
            action: "hemavan_social_posts",
          },
          function (response) {
            scope.data = response;

            alert(scope.data);

            scope.renderTemplate();
          }
        );
      },

      renderTemplate: function () {
        var scope = this,
          html = "";

        if (typeof scope.data === "undefined") {
          scope.config.resultsEl.find(".no-data-found").show();
          return;
        }

        var index = 0;

        html = '<div class="row flex-row">';

        $.each(scope.data, function (i, item) {
          var icon = "fa fa-" + item.source + "-square",
            hiddenClass = "",
            target =
              item.source === "blog" || item.source === "youtube"
                ? ""
                : ' target="_blank"';

          // icons
          if (item.source !== "sommartopparhemavantarnaby") {
            return;
          } else {
            index++;
          }

          if (index > 6) {
            hiddenClass = "hidden";
          }

          html +=
            '<div class="col-sm-6 col-md-4 feed-item ' +
            hiddenClass +
            " source-" +
            item.source +
            '">';
          html +=
            '<a href="' + item.permalink + '" class="inside"' + target + ">";
          html += '<div class="item-content">';

          if (typeof item.thumbnail !== "undefined") {
            html +=
              '<figure class="feed-item-bg" style="background-image: url(' +
              item.thumbnail +
              ');"></figure>';
          }

          html += '<div class="feed-item-content">';

          if (typeof item.content !== "undefined" && "" !== item.content) {
            html += "<p>" + item.content + "</p>";
          }

          html += "</div>";

          html += "</div></a>";

          html += "</div>";
        });

        html += "</div>";
        scope.config.component.html(html);

        if (scope.config.component.find(".feed-item").length > 6) {
          scope.config.component.find(".button-area").show();
        }
      },
    },
  };

  // publish
  root.app = app;

  // init
  $(root).ready(function () {
    app.init();
  });
})(window, document, jQuery);
